
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import ChatController from '../../../controllers/Chat';

const msgHandler = msgable => {   // REVIEW REDUNDANTE en todos los formularios, SocialLogin y ChatSidebar
  if( msgable.msg) alert( msgable.msg);
}

const errorHandler = async executable => {
  try {
    await executable();
  } catch( error) {
    msgHandler( error);
  }
}

const Register = props => {

  const inputs = {
    name: null, userName: null, mail: null, mail2: null, password: null, password2: null,
  }

  const onSend = async () => {
    if( inputs.password.value !== inputs.password2.value) {
      alert( 'Los campos de password no coinciden, reviselos.');
    } else if( inputs.mail.value !== inputs.mail2.value) {
      alert( 'Los campos de mail no coinciden, reviselos.');
    } else {
      await errorHandler( async () => {
        const response = await ChatController.register( props.chatConfiguration, inputs.name.value, inputs.userName.value, inputs.password.value, inputs.mail.value);
        msgHandler( response);
        if( props.clearForm) props.clearForm();
      });
    }
  };

  const enterHandler = async event => {
    if( event.key === 'Enter') await onSend();
  };

  useEffect( _ => {
    ReactDOM.findDOMNode( inputs.name).focus();
  }, [ inputs.name ]);

  return (
    <div className={'padding-input'}>
      <div className={'column'}>
        <label> Name: </label>
        <input className={'form-control'} ref={ ref => inputs.name = ref } onKeyDown={ enterHandler }></input>
      </div>
      <div className={'column'}>
        <label> Username: </label>
        <input className={'form-control'} ref={ ref => inputs.userName = ref } onKeyDown={ enterHandler }></input>
      </div>
      <div className={'column'}>
        <label> Mail: </label>
        <input className={'form-control'} ref={ ref => inputs.mail = ref } onKeyDown={ enterHandler }></input>
      </div>
      <div className={'column'}>
        <label> Repeat mail: </label>
        <input className={'form-control'} ref={ ref => inputs.mail2 = ref } onKeyDown={ enterHandler }></input>
      </div>
      <div className={'column'}>
        <label> Password: </label>
        <input className={'form-control'} ref={ ref => inputs.password = ref } type='password' onKeyDown={ enterHandler }></input>
      </div>
      <div className={'column'}>
        <label> Repeat password: </label>
        <input className={'form-control'} ref={ ref => inputs.password2 = ref } type='password' onKeyDown={ enterHandler }></input>
      </div>
      <div className={'btn-group pull-right'}>
        <br />
        <button className={'cancel'} onClick={ props.clearForm }> Cancel </button>
        <button className={'submit'} onClick={ onSend }> Sing Up </button>
      </div>
    </div>
  );
};

export default Register;
